import styled from "styled-components";

const StyledEmoji = styled.span``;

export default StyledEmoji;
